import { awaitTimeout } from "@solvari/utils";

// 1 s bound starts at the first call → no consumer hangs on a page that never creates a client.
const loadedTimeout = 1000;

let loaded: Promise<void> | null = null;
let resolveLoaded: (() => void) | null = null;
let isLoaded = false;

function whenAbTestingLoaded(): Promise<void> {
  if (isLoaded) {
    return Promise.resolve();
  }

  loaded ??= Promise.race([
    new Promise<void>((resolve) => {
      resolveLoaded = resolve;
    }),
    awaitTimeout(loadedTimeout).then(() => undefined),
  ]);

  return loaded;
}

function markAbTestingLoaded(): void {
  isLoaded = true;
  resolveLoaded?.();
}

// Specs only: the deferred is module state and outlives a single test.
function resetAbTestingLoaded(): void {
  loaded = null;
  resolveLoaded = null;
  isLoaded = false;
}

export {
  loadedTimeout,
  markAbTestingLoaded,
  resetAbTestingLoaded,
  whenAbTestingLoaded,
};
